const reviewPapers = {
  // tableConfig: {
  //   showCheckbox: true
  // },
  queryList: [
    {
      name: 'year',
      label: '批次',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    },
    {
      name: 'year',
      label: '送审单位',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    },
    {
      name: 'name',
      label: '姓名',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    }
  ],
  urlMap: {
    select: {
      url: '/school/schoolBatch/list',
      data: {
        sendType: '{default.sendType}'
      }
    }
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'auditYear',
      label: '序号'
    },
    {
      name: 'seasonName',
      label: '批次'
    },
    {
      name: 'name',
      label: '送审单位'
    },
    {
      name: 'sendTypeName',
      label: '姓名'
    },
    {
      name: 'reviewEndTime',
      label: '论文题目'
    }
  ]
}
export default reviewPapers



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/customerThesis/reviewPapers.js